/**
 * The ONE rule for showing a phone number on screen (product, 2026-09-17):
 * every digit but the LAST FOUR hidden, the country code kept —
 *
 *   maskPhone(91, "9876543210")  ->  "+91 XXXXX X3210"
 *   maskPhone(null, 9876543210)  ->  "XXXXX X3210"
 *   maskPhone(1, "4155550123")   ->  "+1 XXXXX X0123"
 *   maskPhone(44, "7911123456789") -> "+44 XXXXXXXXX6789"
 *
 * A ten-digit number is grouped 5 + 5 like an Indian mobile; any other length
 * is one run. A number stored WITH its country code in front ("919876543210"
 * beside countryCode 91) loses that copy first. No digits gives "". Four digits
 * or fewer are shown as they are (there is nothing left to hide).
 *
 * DISPLAY ONLY. Never send, dial, compare or search with the result — keep the
 * stored number for those.
 *
 * This file exists at the same path in phr-frontend and bridge-frontend and
 * must stay identical in both.
 */
const asText = (v) => (v === null || v === undefined ? "" : String(v));

export const maskPhone = (countryCode, phone) => {
  const cc = asText(countryCode).replace(/\D/g, "");
  let digits = asText(phone).replace(/\D/g, "");
  if (!digits) return "";
  if (cc && digits.length === cc.length + 10 && digits.startsWith(cc)) digits = digits.slice(cc.length);
  const last = digits.slice(-4);
  const hidden = "X".repeat(Math.max(0, digits.length - 4));
  const masked =
    digits.length === 10 ? `${hidden.slice(0, 5)} ${hidden.slice(5)}${last}` : `${hidden}${last}`;
  return cc ? `+${cc} ${masked}` : masked;
};

/**
 * For a number already joined with its country code ("+91-9876543210",
 * "+91 98765 43210", "919876543210" is NOT recognised — a leading "+" is what
 * marks the code): splits on the first separator after the "+" and masks.
 */
export const maskJoinedPhone = (joined) => {
  const text = asText(joined).trim();
  const m = text.match(/^\+(\d{1,4})[\s-]+(.*)$/);
  return m ? maskPhone(m[1], m[2]) : maskPhone(null, text);
};

export default maskPhone;
